import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolboxModule } from '../shared/toolbox/toolbox.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ExploreModule } from '../explore/explore.module';
import {SearchComponent} from '../shared/toolbox/search/search.component';



@NgModule({
  declarations: [
    LandingPageComponent
  ],
	imports: [
		CommonModule,
		ToolboxModule,
		ExploreModule,
		SearchComponent,

	],
  exports:[LandingPageComponent],
})
export class LandingModule { }
